var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResurveyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8984 5.33929C27.1229 7.74604 28.4821 10.9643 28.4821 14.5C28.4821 21.9558 22.438 28 14.9821 28C12.8736 28 10.878 27.5166 9.1 26.6546M24.8984 5.33929L23.1786 10.6429M24.8984 5.33929L30.4107 5.82143M6.05249 24.625C3.24982 22.1513 1.48214 18.5321 1.48214 14.5C1.48214 7.04416 7.5263 1 14.9821 1C17.5776 1 20.0021 1.73246 22.06 3.00196M6.05249 24.625L7.26786 19.8036M6.05249 24.625H1",
    stroke: "#313131",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9609 6.39844V15.5784H20.9809",
    stroke: "#313131",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResurveyIcon);
export default __webpack_public_path__ + "static/media/resurvey-icon.d05879002f8ec53a06224bc84f1ce3df.svg";
export { ForwardRef as ReactComponent };